<template>
  <div v-if="apparance == 'solid'" :class="'h-px bg-gray-100 ' + margin"></div>
  
    <div v-else class="or-container-divider flex items-center justify-center gap-2">
      <svg
        width="212"
        height="2"
        viewBox="0 0 212 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.5" width="211.5" height="1" fill="url(#paint0_linear_1_3)" />
        <defs>
          <linearGradient
            id="paint0_linear_1_3"
            x1="-6.7631e-07"
            y1="1.0005"
            x2="211.768"
            y2="1.28778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="#8D9ADF" />
          </linearGradient>
        </defs>
      </svg>

      <small>or</small>

      <svg
        width="212"
        height="2"
        viewBox="0 0 212 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="212"
          y="1.5"
          width="211.5"
          height="1"
          transform="rotate(-180 212 1.5)"
          fill="url(#paint0_linear_1_5)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1_5"
            x1="212"
            y1="2.0005"
            x2="423.768"
            y2="2.28778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="#8D9ADF" />
          </linearGradient>
        </defs>
      </svg>
    </div>
</template>

<script>
export default {
  props: {
    margin: {
      type: String,
      default: "my-10",
    },
    apparance: {
      type: String,
      default: "solid", // 'solid', 'or'
      validator: function (value) {
        return ["solid", "or"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {};
  },
};
</script>
